<script lang="ts">
    import type {Category, CategoryCountResponse} from "../NvbsSearchEngineApi/interfaces";
    import {onMount, tick} from "svelte";
    import {NvbsSearchEngineApi} from "../NvbsSearchEngineApi/NvbsSearchEngineApi";
    import NumberDisplay from "../common/NumberDisplay.svelte";

    let {
        categories = [],
        query = "",
        searchStore = $bindable(),
        categorySelected,
    }: {
        categories: Category[],
        query: string,
        searchStore: any,
        categorySelected: (category: Category) => void,
    } = $props();

    let categoryCounts: CategoryCountResponse = $state({});

    $effect(() => {
        NvbsSearchEngineApi.getCategoryCounts({
            query: query,
            ocr: searchStore.ocr,
            exact_match: searchStore.exact_match
        }).then((response => {
            categoryCounts = response;
        }));
    })
</script>

<div class="category-blocks">
    {#each categories as category}
        {@const categoryCount = categoryCounts[category.name] || 0}
        <button class="category-block"
                disabled={categoryCount === 0}
            onclick={() => {
                categorySelected(category);
            }}
        >
            <div class="category-block-name">
                {category.label}
            </div>
            <div class="category-block-count">
                <NumberDisplay number={categoryCount} />
            </div>
        </button>
    {/each}
</div>

<style lang="scss">
    .category-blocks {
      display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 10px;

      .category-block {
        border: none;
        background-color: #f0f0f0;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        transition: background-color 0.3s;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:hover {
            background-color: #e0e0e0;
        }

        .category-block-name {
            font-weight: bold;
            margin-bottom: 5px;
          color:#1F4588;
        }

        .category-block-count {
            color: #666;
            font-size: 2em;
        }

        &:disabled {
          cursor: not-allowed;
          opacity: .3;
        }
      }

    }
</style>
